import { render, staticRenderFns } from "./SendSmsButton.vue?vue&type=template&id=0aa6ea20&scoped=true&"
import script from "./SendSmsButton.vue?vue&type=script&lang=js&"
export * from "./SendSmsButton.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsButton.vue?vue&type=style&index=0&id=0aa6ea20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa6ea20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa6ea20')) {
      api.createRecord('0aa6ea20', component.options)
    } else {
      api.reload('0aa6ea20', component.options)
    }
    module.hot.accept("./SendSmsButton.vue?vue&type=template&id=0aa6ea20&scoped=true&", function () {
      api.rerender('0aa6ea20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SmsSettings/SendSmsButton.vue"
export default component.exports